export default __webpack_public_path__ + "static/media/about_2.70bc3912.jpg";